import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const sourceTypeResolver: FieldResolver = (metadata: Metadata) =>
  ({ sourceType: metadata.getSourceType() } as StreamData)

export default sourceTypeResolver
